import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { getMyEstimateList } from '../api/estimate';
import Loading from '../components/common/Loading';
import PhoneVerification from '../components/common/PhoneVerification';
import PageTitle from '../components/layout/PageTitle';

/** 나의 견적 확인 - 휴대폰 문자 본인확인으로 조회한다. (PC/모바일 공통) */
export default function MyEstimateSearch() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState('');
  const [verificationToken, setVerificationToken] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = '나의견적확인 | 이케이하나관광 버스대절';
  }, []);

  const search = (token) => {
    const form = { phone, verificationToken: token };
    setLoading(true);
    setMessage('');
    getMyEstimateList(form, 1)
      .then((response) => {
        const list = response?.estimateList ?? [];
        if (list.length < 1) {
          setMessage('해당 번호로 등록된 견적이 없습니다.');
          return;
        }
        navigate('/my/list/1', { state: { form } });
      })
      .catch((error) =>
        setMessage(error?.response?.data?.message || '조회 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
      )
      .finally(() => setLoading(false));
  };

  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 3, md: 5 } }}>
      <PageTitle title='나의 견적 확인' />

      <Paper elevation={3} sx={{ p: { xs: 2.5, md: 4 }, borderRadius: 3 }}>
        <Typography sx={{ mb: 2, fontSize: 14, color: '#6b5544', wordBreak: 'keep-all' }}>
          견적 등록 시 입력하신 휴대폰 번호로 본인확인을 하시면 요청하신 견적을 확인할 수 있습니다.
        </Typography>

        {message && (
          <Alert severity='warning' sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        <Stack spacing={2}>
          <PhoneVerification
            label='휴대폰 번호'
            phone={phone}
            onPhoneChange={setPhone}
            verified={Boolean(verificationToken)}
            onVerified={(token) => {
              setVerificationToken(token);
              search(token);
            }}
            onReset={() => setVerificationToken(null)}
          />

          <Stack direction='row' spacing={1} justifyContent='center'>
            <Button
              variant='contained'
              disabled={!verificationToken}
              onClick={() => search(verificationToken)}
              sx={{
                backgroundColor: '#1B3C7A',
                fontWeight: 800,
                px: 3,
                '&:hover': { backgroundColor: '#122C5C' },
              }}
            >
              내 견적 보기
            </Button>
            <Button
              variant='outlined'
              onClick={() => navigate(-1)}
              sx={{ color: '#5A4231', borderColor: '#5A4231' }}
            >
              취소
            </Button>
          </Stack>
        </Stack>
      </Paper>

      <Loading open={loading} />
    </Box>
  );
}
